module.exports = __webpack_public_path__ + "media/images/common/purchase_btn_ov-aa19e39f5662e9fcab78043abff2c013.gif";